// src/PublicUser/components/CategoryFilter.jsx
import React from 'react';

const categories = [
  'All', 
  'Development', 
  'API', 
  'Frontend', 
  'Database', 
  'Cloud', 
  'DevOps', 
  'AI/ML'
];

const CategoryFilter = ({ selectedCategory, onCategoryChange,categories }) => {
  const categoryList = categories.length > 0 
    ? [{ name: 'All', id: null }, ...categories]
    : [{ name: 'All', id: null }];

  return (
    <div className="ts-category-filter">
      <span className="ts-filter-label">Filter by:</span>
      <div className="ts-category-chips">
        {categoryList.map(category => (
          <button
            key={category.id || category.name}
            className={`ts-category-chip ${selectedCategory === category.name ? 'ts-active' : ''}`}
            onClick={() => onCategoryChange(category.name, category.id)}
          >
            {category.name}
            {selectedCategory === category.name && <span className="ts-chip-indicator"></span>}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;
